import type { ChatHistoryListResponse } from '@/domains/traffic-monitoring/types/report-chat.types';
import { request } from '@/shared/utils/request';

export const reportChatApi = {
  // GET /api/dsh/whatsapp/report/{report_id}/chat -> { report_id, total_count, chat_list[] }
  getChatHistory: async (reportId: number): Promise<ChatHistoryListResponse> => {
    return request.get<ChatHistoryListResponse>(`/whatsapp/report/${reportId}/chat`);
  },
};
